import { RecentUploads } from '@/pages/public-profile/profiles/default';
import { BasicSettings, CalendarAccounts, CommunityBadges, Connections, PersonalInfo, StartNow, Work } from './blocks';
import { useAuthContext } from '@/auth';
import profileService from '@/services/setting/profileService';
import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import axios from 'axios';
import { FormattedMessage } from 'react-intl';
import { useIntl } from 'react-intl';
import { isSuperAdmin } from '@/utils';

const AccountUserProfileContent = ({ refreshKey = 0 }) => {
  const { auth, updateUser } = useAuthContext();
  const [profileData, setProfileData] = useState(null)
  const [loading, setLoading] = useState(false);
  const [saveLoading, setSaveLoading] = useState(false)
  const { formatMessage } = useIntl();

  const getProfile = async () => {
    try {
      setLoading(true);
      const {data, status} = isSuperAdmin() 
        ? await profileService.superAdminGetProfile() 
        : await profileService.getProfile();
      if(status) {
        setProfileData(data)
      }
    } catch (error) {
      console.error('Error:', error)
      setLoading(false);
    } finally {
      setLoading(false)
    }
  }

  const updateProfile = async (formData, setErrors) => {
    try {
      setSaveLoading(true);
      const {data, status} = isSuperAdmin() 
        ? await profileService.superAdminUpdateProfile(formData) 
        : await profileService.updateProfile(formData);
      if(status) {
        const updatedUser = {
          first_name: data.user.first_name,
          last_name: data.user.last_name,
          profile_image: data.user.profile_image,
          timezone: data.user.timezone,
        }
        updateUser(updatedUser, true)
        getProfile()
        toast.success(formatMessage({id: 'user_profile.profile_updated_successfully'}), {
          description: `${data.user.first_name + ' ' + data.user.last_name} ${formatMessage({id: 'user_profile.information_updated_successfully'})}`,
          
        });
      }
    } catch (error) {
      console.error('Error:', error)
      if (error.message == '422 Unprocessable Entity. Validation failed.') {
        const responseErrors = error.errors || {};
        const formattedErrors = {};

        Object.entries(responseErrors).forEach(([key, value]) => {
          formattedErrors[key] = value[0];
        });

        setErrors(formattedErrors);

        toast.warning(formatMessage({id: 'user_profile.validation_error'}), {
          description: formattedErrors.profile_image || formatMessage({id: 'user_profile.validation_message'}),
          
        });
        return
      }
      toast.error(formatMessage({id: 'user_profile.failed_to_update_profile'}), {
        description: formatMessage({id: 'user_profile.error_message'}),
        
      });
      setSaveLoading(false);
    } finally {
      setSaveLoading(false)
    }
  }

  useEffect(() => {
    getProfile()
  }, [refreshKey])
  

  return <div className="grid  gap-5 lg:gap-7.5 mb-5">
          <PersonalInfo userData={profileData} onEdit={updateProfile} loading={loading} onSaveLoading={saveLoading} />
        {/* <div className="col-span-1">
        <div className="grid gap-5 lg:gap-7.5">

          <BasicSettings title="Basic Settings" />

          <Work />

          <CommunityBadges />
        </div>
      </div>

      <div className="col-span-1">
        <div className="grid gap-5 lg:gap-7.5">
          <StartNow />

          <CalendarAccounts />

          <Connections url="#" />

          <RecentUploads title="My Files" />
        </div>
      </div> */}
    </div>;
};
export { AccountUserProfileContent };